"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("isomorphic-fetch");
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _clsx = _interopRequireDefault(require("clsx"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _MenuHamburger2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/MenuHamburger"));
var _NotificationDot2 = _interopRequireDefault(require("../components/NotificationDot"));
var _ProfileImage2 = _interopRequireDefault(require("../components/ProfileImage"));
var _useGetUser = _interopRequireDefault(require("../components/useGetUser"));
var _jsxRuntime = require("react/jsx-runtime");
var _ProfileImage, _MenuHamburger, _NotificationDot;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AccountButton = _ref => {
  var _user$unreadMessages;
  let {
    togglePanel
  } = _ref;
  const intl = (0, _reactIntl.useIntl)();
  const user = (0, _useGetUser.default)();
  const unreadMessages = (_user$unreadMessages = user === null || user === void 0 ? void 0 : user.unreadMessages) !== null && _user$unreadMessages !== void 0 ? _user$unreadMessages : 0;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    type: "button",
    onClick: togglePanel,
    "data-test": "TopNav-AccountMenuButton",
    "aria-label": intl.formatMessage({
      id: "navbar.header.open_sidebar"
    }),
    className: (0, _clsx.default)("relative rounded-full border border-cloud-normal p-200", "text-button-link-secondary-foreground focus:text-product-normal-hover active:text-product-normal-active hover:[@media(hover)_and_(pointer:fine)]:text-product-normal-hover", "transition-all duration-fast", "select-none"),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
      grow: false,
      align: "center",
      spacing: "200",
      children: [_ProfileImage || (_ProfileImage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileImage2.default, {})), _MenuHamburger || (_MenuHamburger = /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuHamburger2.default, {})), unreadMessages > 0 && (_NotificationDot || (_NotificationDot = /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotificationDot2.default, {
        dataTest: "TopNav-NotificationDot"
      })))]
    })
  });
};
var _default = exports.default = AccountButton;